import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AwdurdodiService } from "../awdurdodi/awdurdodi.service";

@Injectable({
  providedIn: "root",
})
export class GuardsRolService {
  constructor(private awdurdodiService: AwdurdodiService) {}

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.awdurdodiService.gwirioRol(next.data.rol)) {
      return true;
    }

    return false;
  }
}
